import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=6e50cbb1&scoped=true"
import script from "./CookieLaw.vue?vue&type=script&lang=js"
export * from "./CookieLaw.vue?vue&type=script&lang=js"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=6e50cbb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50cbb1",
  null
  
)

export default component.exports